import styled from 'styled-components'

export const ErrorMessage = styled.p`
  margin: 3px 0 6px 0;
  color: #ab003c;
  text-transform: none;
`
